module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('div', {
    staticClass: "col-md-12 hexagon-container"
  }, _vm._l((_vm.lstItems), function(o, index) {
    return _c('item', {
      key: o.id,
      attrs: {
        "title": o.name,
        "id": o.id,
        "index": index,
        "isSelected": o.selected
      },
      on: {
        "onListSelect": _vm.onSubjectSelected
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d04c769e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subject/BeeHive.vue
// module id = 1652
// module chunks = 0